/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FRAME STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	frame: {
		width: '100%',
		height: '100%',
		// outline: '1px solid #fc3'
	}
};